import { Box, Button, Typography } from '@mui/material';
import { Check } from '@mui/icons-material';
import { t } from 'i18next';
import { FC, Fragment } from 'react';

interface NotificationToastProps {
  description: string;
  viewTaskAction: () => void;
  makeAsReadAction: () => void;
}

export const NotificationToast: FC<NotificationToastProps> = ({
  description,
  viewTaskAction,
  makeAsReadAction,
}) => {
  return (
    <Box sx={{ width: 415 }}>
      <Typography
        variant='body2'
        sx={{ textAlign: 'left', mb: 2, color: 'text.primary' }}
      >
        {description.split(':').map((item, idx) => {
          if (idx !== 0) {
            return <b key={idx}>:{item}</b>;
          }
          return <Fragment key={idx}>{item}</Fragment>;
        })}
      </Typography>

      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          variant='outlined'
          onClick={viewTaskAction}
          sx={{
            flex: 1,
            borderRadius: 0,
            borderColor: '#133F6E',
            color: '#133F6E',
          }}
        >
          {t('header.notifications.toast.viewTask')}
        </Button>
        <Button
          variant='text'
          onClick={makeAsReadAction}
          startIcon={<Check sx={{ color: '#133F6E' }} />}
          sx={{ flex: 1, color: '#133F6E' }}
        >
          {t('header.notifications.toast.markAsRead')}
        </Button>
      </Box>
    </Box>
  );
};
